import React, { Fragment, useState, useEffect, useContext } from 'react';
import { ProjectContext } from '../../../../../../context/Project';
import { formatPrice } from '../../../../../../common/numberFormat';
import ContinueButton from '../ContinueButton';

function TotalEstimationSticky() {
    const { projectTotalBudget } = useContext(ProjectContext);

    const [totalBudget, setTotalBudget] = useState(0);
    const [scrollYPosition, setScrollYPosition] = useState(0);
    const [showSticky, setShowSticky] = useState(false);

    useEffect(() => {
        setShowSticky(shouldShowSticky());
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
        
    useEffect(() => {
        if (projectTotalBudget && projectTotalBudget > 0) {
            setTotalBudget(projectTotalBudget);
        } else {
            if (totalBudget > 0) {
                setTotalBudget(0);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectTotalBudget]);

    useEffect(() => {
        setShowSticky(shouldShowSticky());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollYPosition]);

    const handleScroll = () => {
        setScrollYPosition(window.scrollY);
    };

    const shouldShowSticky = () => {
        const offsetHeight = document.documentElement.offsetHeight;
        const innerHeight = window.innerHeight;
        const scrollTop = document.documentElement.scrollTop;
        
        return offsetHeight - (innerHeight + scrollTop) > 500;
    }

    return (
        <Fragment>
            {
                (totalBudget > 0 && showSticky) &&
                <section id="estimated-budget-sticky">
                    <span className="total">
                        Total estimated {formatPrice(totalBudget)}
                    </span>
                    <ContinueButton className="continue"/>
                </section>
            }
        </Fragment>
    );
}

export default TotalEstimationSticky;